import { render, staticRenderFns } from "./JcomTableList.vue?vue&type=template&id=f7ac6d56"
import script from "./JcomTableList.vue?vue&type=script&lang=js"
export * from "./JcomTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports